import { REDIRECT_KEY_STORAGE } from '@constants';
import useAuth from '@contexts/AuthProvider';
import { useRegisterContext } from '@contexts/RegisterProvider';
import { Button, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import AlreadyAuthenticated from './AlreadyAuthenticated';
import AuthMethodSelection from './AuthMethodSelection';

export default function AuthMethods() {
  useTranslation();
  const navigate = useNavigate();
  const { authenticated, tokenParsed } = useAuth();
  const { company, isLoading, registrationCode, hasInitialCode } = useRegisterContext();

  useEffect(() => {
    if (!registrationCode) {
      sessionStorage.removeItem(REDIRECT_KEY_STORAGE);
      void navigate('/', { replace: true });
      return;
    }

    if (!company) {
      if (isLoading) return;
      sessionStorage.removeItem(REDIRECT_KEY_STORAGE);
      void navigate('/', { replace: true });
      return;
    }

    sessionStorage.setItem(REDIRECT_KEY_STORAGE, '/redeem');
  }, [navigate, company, registrationCode, isLoading]);

  return (
    <Stack sx={{ gap: 2 }}>
      <Stack sx={{ gap: 1, width: '100%' }}>
        <Typography variant="h5">
          <Trans i18nKey="registration.title" />
        </Typography>
        <Typography data-test-id={`employer-${company?.name}`}>
          <Trans i18nKey="registration.employer" values={{ companyName: company?.name }} />
        </Typography>
      </Stack>
      {authenticated && tokenParsed ? <AlreadyAuthenticated /> : <AuthMethodSelection />}
      {!hasInitialCode && (
        <Button variant="outlined" onClick={() => navigate('/')} role="link">
          <Trans i18nKey="common.actions.back" />
        </Button>
      )}
    </Stack>
  );
}
